

// ============================================================
// [DESACTIVADO] — Ordenar colección por disponibilidad
// ============================================================
/*
(function () {
  function initCollectionAvailabilitySort() {
    const list = document.querySelector('.product-list[data-sort-handle]');
    if (!list) return;

    const handle   = list.dataset.sortHandle;
    const pageSize = parseInt(list.dataset.sortPagesize) || 48;
    const params   = new URLSearchParams(window.location.search);
    const curPage  = parseInt(params.get('page') || '1');

    const userSort = params.get('sort_by');
    if (userSort && userSort !== 'manual') return;

    function eur(amount) {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(parseFloat(amount) || 0);
    }

    async function fetchAll() {
      let all = [], pg = 1;
      while (true) {
        const r = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + pg);
        if (!r.ok) break;
        const { products } = await r.json();
        if (!products || !products.length) break;
        all = all.concat(products);
        if (products.length < 250) break;
        pg++;
      }
      return all;
    }

    // Construye una tarjeta para productos cross-page (no están en el DOM actual)
    function buildCard(p, eager) {
      const avail    = p.available || (Array.isArray(p.variants) && p.variants.some(v => v.available));
      const fv       = Array.isArray(p.variants) ? (p.variants[0] || {}) : {};
      const hasVar   = Array.isArray(p.variants) && p.variants.length > 1;
      // featured_image es objeto {src:"https://..."} o null
      const imgSrc   = (p.featured_image && p.featured_image.src)
                       || (Array.isArray(p.images) && p.images[0] && p.images[0].src)
                       || null;
      // price_min ya viene en euros como string ("19.99"), no en centavos
      const priceMin = parseFloat(p.price_min || (fv.price) || '0');
      const cmpMax   = parseFloat(p.compare_at_price_max || '0');
      const safe     = (s) => (s || '').toString().replace(/"/g, '&quot;').replace(/</g, '&lt;');

      const imgHtml = imgSrc
        ? `<img src="${imgSrc}" class="offtv-pro-card__image" alt="${safe(p.title)}" loading="${eager ? 'eager' : 'lazy'}">`
        : `<div class="offtv-pro-card__image" style="background:#1a1a1a"></div>`;

      const wlBtn = `<button type="button" class="offtv-wl-btn offtv-wl-btn--card" data-wl-btn
        data-product-id="${p.id}" data-product-handle="${p.handle}"
        data-product-title="${safe(p.title)}"
        data-product-price="${Math.round(priceMin * 100)}"
        data-product-image="${imgSrc || ''}"
        data-product-url="/products/${p.handle}"
        data-product-variant-id="${fv.id || ''}"
        aria-label="Guardar ${safe(p.title)}" title="Guardar en lista de deseos">
        <svg class="offtv-wl-btn__icon offtv-wl-btn__icon--empty" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        <svg class="offtv-wl-btn__icon offtv-wl-btn__icon--filled" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
      </button>`;

      const cmpHtml = (cmpMax && cmpMax > priceMin)
        ? `<span class="offtv-pro-card__compare-price">${eur(cmpMax)}</span>` : '';

      const cta = avail
        ? `<button type="button" class="offtv-pro-card__cart-btn"
            data-variant-id="${fv.id || ''}" data-has-variants="${hasVar}"
            data-product-handle="${p.handle}" data-product-url="/products/${p.handle}"
            onclick="event.preventDefault();event.stopPropagation();addOffTvCardToCart(this);"
            aria-label="Añadir al carrito">
            <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg></button>`
        : `<span class="offtv-pro-card__sold-out-btn">Agotado</span>`;

      return `<a href="/products/${p.handle}" class="offtv-pro-card${avail ? '' : ' offtv-pro-card--sold-out'}">
        <div class="offtv-pro-card__img-wrap">
          ${imgHtml}
          ${avail ? '' : '<div class="offtv-pro-card__sold-out-badge">AGOTADO</div>'}
          ${wlBtn}
        </div>
        <div class="offtv-pro-card__info">
          <div class="offtv-pro-card__text">
            <div class="offtv-pro-card__vendor">${p.vendor || ''}</div>
            <h3 class="offtv-pro-card__title">${p.title || ''}</h3>
          </div>
          <div class="offtv-pro-card__bottom">
            <div class="offtv-pro-card__prices">${cmpHtml}<span class="offtv-pro-card__price">${eur(priceMin)}</span></div>
            ${cta}
          </div>
        </div>
      </a>`;
    }

    async function run() {
      // 1. Snapshot de los nodos ya renderizados por Liquid (perfectos: imagen, stock, precio)
      const existingCards = Array.from(list.querySelectorAll('.offtv-pro-card'));
      if (!existingCards.length) return;

      // Ocultar inmediatamente para evitar el flash del contenido sin ordenar
      list.style.opacity = '0';

      const domByHandle = {};
      existingCards.forEach(el => {
        const href = el.getAttribute('href') || '';
        const h    = href.split('/products/')[1]?.split('?')[0]?.split('#')[0];
        if (h) domByHandle[h] = el;
      });

      const reveal = () => {
        list.style.transition = 'opacity 0.3s ease';
        list.style.opacity    = '1';
      };

      try {
        // 2. Obtener todos los productos para el orden global
        const all = await fetchAll();
        if (!all.length) { reveal(); return; }

        // 3. Ordenar: disponibles primero (variante-level para mayor fiabilidad)
        all.sort((a, b) => {
          const aA = a.available || (Array.isArray(a.variants) && a.variants.some(v => v.available));
          const bA = b.available || (Array.isArray(b.variants) && b.variants.some(v => v.available));
          if (aA === bA) return 0;
          return aA ? -1 : 1;
        });

        // 4. Página virtual actual
        const start    = (curPage - 1) * pageSize;
        const pageProd = all.slice(start, start + pageSize);
        if (!pageProd.length) { reveal(); return; }

        // 5. Construir resultado:
        //    - productos ya en el DOM → usar el nodo Liquid (imagen y stock correctos)
        //    - productos cross-page   → construir tarjeta desde datos de la API
        const frag = document.createDocumentFragment();
        pageProd.forEach((p, i) => {
          if (domByHandle[p.handle]) {
            frag.appendChild(domByHandle[p.handle]);
          } else {
            const tmp = document.createElement('div');
            tmp.innerHTML = buildCard(p, i < 4);
            const el = tmp.firstElementChild;
            if (el) frag.appendChild(el);
          }
        });

        if (!frag.childNodes.length) { reveal(); return; }

        // 6. Sustituir y revelar con fade-in suave
        list.innerHTML = '';
        list.appendChild(frag);
        reveal();

        if (typeof window.offtvWishlist?.init === 'function') window.offtvWishlist.init();

      } catch (err) {
        console.warn('[OffTV Sort]', err);
        reveal(); // Siempre revelar aunque falle el sort
      }
    }

    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionAvailabilitySort);
  } else {
    initCollectionAvailabilitySort();
  }
})();
*/

// Start script for partner.liquid section

const carousels = document.querySelectorAll('.partnerContainerInner');
const categoriesBtns = document.querySelectorAll('.category-btn');

function updateOptions() {
  carousels.forEach(carousel => {
    let options = {
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      groupCells: 1,
      arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 }
    };
  
    const partnerLogos = carousel.querySelectorAll('.partnerChild').length;
  
    if (matchMedia('screen and (min-width: 991px)').matches) {
      options.groupCells = partnerLogos >= 4 ? 4 : 1;
    } else if (matchMedia('screen and (min-width: 700px)').matches && matchMedia('screen and (max-width: 990px)').matches) {
      options.groupCells = partnerLogos >= 3 ? 3 : 1;
    } else if (matchMedia('screen and (max-width: 699px)').matches) {
      options.groupCells = 1;
    }
  
    carousel.setAttribute('data-flickity', JSON.stringify(options));
  });
}

updateOptions();
window.addEventListener('resize', updateOptions);

const filterCategories = (event) => {
  const category = event.target.getAttribute('data-category');

  // Remove the active class from all category buttons
  const categoriesBtns = document.querySelectorAll('.category-btn');
  categoriesBtns.forEach((btn) => {
    btn.classList.remove('category-btn--active');
  });

  // Add the active class to the clicked button
  event.target.classList.add('category-btn--active');

  // Show/hide partnerContainerInner based on category
  carousels.forEach((partnerContainerInner) => {
    if (partnerContainerInner.getAttribute('data-partnerCategory') == category) {
      partnerContainerInner.style.display = 'block';
    } else {
      partnerContainerInner.style.display = 'none';
    }
  }); 
};

updateOptions(); 

// Show all carousels first
carousels.forEach((partnerContainerInner) => {
  partnerContainerInner.style.display = 'block';
});

// Set the first category button to active by default, 
// added the if conditional to avoid getting console undefined error on pages where this section isn't available
if (categoriesBtns.length > 0 ) {
categoriesBtns[0].classList.add('category-btn--active');
setTimeout(function() {
  categoriesBtns[0].click();
}, 100); 
}
// the modal part scripts 
document.addEventListener("DOMContentLoaded", function() {
    // Get all partnerChild elements
    const partnerChildElems = document.querySelectorAll(".partnerChild");

    // Create the modal element
    const modal = document.createElement("div");
    modal.classList.add("modal");
    modal.style.display = "none";

    // Create the modal content element
    const modalContent = document.createElement("div");
    modalContent.classList.add("modal-content-outer");
    modal.appendChild(modalContent);

    // Add the modal to the document
    document.body.appendChild(modal);

    // Loop through each partnerChild element
    partnerChildElems.forEach(partnerChild => {
        partnerChild.addEventListener("click", function() {
        // Get the content and button information from the data attributes
        const partnerContent = this.getAttribute('data-partnerContent');
        const partnerChildImage = this.querySelector('img');
        const partnerLogo = partnerChildImage.src;
        const partnerName = this.getAttribute('data-partnerName')
        const partnerBtnLabel = this.getAttribute('data-partnerBtnLabel');
        const partnerBtnLink = this.getAttribute('data-partnerBtnLink');
        
        // Update the modal content with the information
        modalContent.innerHTML = `
            <div class="modal-content br1p4">
            <div class="leftPartnerModal brTlBl"> <img class="brTlBl mA" src=${partnerLogo}> </div>
            <div class="rightPartnerModal pLR16">
                <button class="closeModalBtn"> <svg stroke="currentColor" fill="none" stroke-width="4" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
                <p class="fw7 H3-v2 lh-1p2 mB24"> ${partnerName} </p>
                <p class="rightPartnerModalContent fs15"> ${partnerContent} </p> 
            <a href="${partnerBtnLink}" target="_blank" class="modal-btn Button Button--primary">${partnerBtnLabel}</a>
            </div>
            </div>
        `;
        
        // Show the modal
        modal.style.display = "block";

        // Close the modal when clicking the close button
        modalContent.querySelector(".closeModalBtn").addEventListener("click", function() {
            modal.style.display = "none";
        });
        });
    });

    // Close the modal when clicking outside of it
    window.addEventListener("click", function(event) {
        if (event.target === modalContent) {
        modal.style.display = "none";
        }
    });
});

//***************************

// START script for blog-carousel.liquid section

// ADD event listener to .block divs
const blocks = document.querySelectorAll(".block");
blocks.forEach((block) => {
  block.addEventListener("click", showModal);
});

function showModal(event) {
  // GET data-target value of the clicked div
  const target = event.currentTarget.getAttribute("data-target");
  
  // Find the modal with the same data-target value and display it
  const modal = document.querySelector(`.blogPostsModal[data-target="${target}"]`);
  modal.classList.remove('blogPostsModal-closed');
  modal.style.display = "block";
  document.body.style.overflow = 'hidden';
    
  // There are some span tags that have some inline styling from the blog posts and are showing in the page
  // had to remove them with js instead of going and modifying each one 
  const blogPostsListContentDivs = document.querySelectorAll('.blogPostsListContent');

  blogPostsListContentDivs.forEach(div => {
    const span = div.querySelector('p span');
    if (span) {
      span.removeAttribute('style');
    }
  });

  // Close the modal when clicking the close button, outside and ESC key
  const closeButton = modal.querySelector(".blogPostsModalClose");
  closeButton.addEventListener("click", () => {
    modal.classList.add('blogPostsModal-closed');
    modal.style.display = "none";
    document.body.style.overflow = 'auto';
  });

  modal.addEventListener("click", (event) => {
    if (event.target.classList.contains("blogPostsModal")) {
      modal.style.display = "none";
      document.body.style.overflow = 'auto';
    }
  });

  // const existingVideoContainer = document.querySelector(".blogPostsVideoContainer");
  // if ( !existingVideoContainer ) {
  //   document.addEventListener('keyup', (event) => {
  //     if (event.key === 'Escape') {
  //       modal.style.display = "none";
  //     }
  //   });
  // }
  
}

 // ADD event listener to .blogPostsListInner divs
 const blocksInner = document.querySelectorAll(".blogPostsListInner");
 blocksInner.forEach((block) => {
  if (block.hasAttribute("data-video-id")) {
    block.addEventListener("click", showVideoModal);
  }
 });
 
 function showVideoModal(event) {
   // GET data-video-id value of the clicked div
   const videoId = event.currentTarget.getAttribute("data-video-id");

   // it was creating 2 divs so first we check if a video container already exists, and if it does, remove it
   const existingVideoContainer = document.querySelector(".blogPostsVideoContainer");
   if (existingVideoContainer) {
     existingVideoContainer.parentNode.removeChild(existingVideoContainer);
   }
 
   // Create the blogPostsVideoContainer div and the content
   const videoContainer = document.createElement("div");
   videoContainer.classList.add("blogPostsVideoContainer");

   const videoContainerInner = document.createElement("div");
   videoContainerInner.classList.add("blogPostsVideoContainerInner");
 
   const iframe = document.createElement("iframe");
   iframe.classList.add("bAllSides--transparent", "imgBr", "videoContainerDimensions");
  //  iframe.setAttribute("width", "760");
  //  iframe.setAttribute("height", "415");
   iframe.setAttribute("src", videoId);
   iframe.setAttribute("allow", "picture-in-picture; web-share");
   iframe.setAttribute("allowfullscreen", "");
 
   const closeButton = document.createElement("button");
   closeButton.classList.add("blogPostsVideoClose");
   closeButton.innerHTML = '<svg stroke="currentColor" fill="none" stroke-width="4" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"> <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
 
   videoContainerInner.appendChild(iframe);
   videoContainerInner.appendChild(closeButton);
   videoContainer.appendChild(videoContainerInner);
   
 
   // Append the blogPostsVideoContainer to the body
   document.body.appendChild(videoContainer);

   // Close the video container when close btn, outside and ESC key
   closeButton.addEventListener("click", () => {
    videoContainer.remove()
   });

   videoContainer.addEventListener("click", (event) => {
     if (event.target === videoContainer) {
       videoContainer.remove();
     }
   });

   document.addEventListener('keyup', (event) => {
     if (event.key === 'Escape') {
       videoContainer.remove();
     }
   });
 }


//***************************//

/* sidebar menu shop */

const sidebarShopBtn = document.getElementById('btnMenuShopDrawer');
const sidebarDrawerShop = document.getElementById('sidebar-menu-shop');
const closeSidebarDrawerShop = sidebarDrawerShop?.querySelector('.Drawer__Close');

if (sidebarShopBtn) {
  sidebarShopBtn.addEventListener('click', () => {
    sidebarDrawerShop.ariaHidden="false";
  });
}

if (closeSidebarDrawerShop) {
  closeSidebarDrawerShop.addEventListener('click', () => {
    sidebarDrawerShop.ariaHidden="true";
  });
}



/* ywh tv */

const ywhTvCarrousels = document.querySelectorAll('.ywh-tv-carrousel');
  setTimeout(()=> {
    // ywhTvCarrousels.forEach(el => el.classList.remove('ywh-tv-carrousel--height'))
  }, 4000)


  /* CUSTOM-PRODUCT-CARD.LIQUID -- Gallery block */

  /*
    The script will not execute if no gallery elements are found.
    
    structure of a Gallery Element:
      1- each gallery must have a unique 'data-id' attribute to differentiate between multiple galleries on the same page.
    
      2- Within each gallery, there should be:
        -- radio input elements with the class 'Gallery__ThumbnailInput' for thumbnail selection.
          - these inputs must have an 'id' attribute formatted as "{{ block.id }}-{{ image.id }}". 
          - the 'name' attribute for these inputs should be formatted as "gallery-{{ block.id }}" ensuring that thumbnail selection is grouped by gallery.
        -- a container with the class 'Gallery__CurrentImage' for displaying full-size images.
          - Each image within this container should have an 'id' attribute that matches its corresponding thumbnail's image ID: "{{ image.id }}".
    
    Expected Behavior:
      - when a thumbnail input ('Gallery__ThumbnailInput') is selected (via a 'change' event), the script identifies the corresponding full-size image in the 'Gallery__CurrentImage' container.
      - the 'selected-image' class is added to the identified image
  */
 
  document.addEventListener('DOMContentLoaded', function() {
    const galleries = document.querySelectorAll('.Gallery');

    galleries.forEach(function(gallery) {
      const galleryId = gallery.getAttribute('data-id');
      const thumbnails = gallery.querySelectorAll('.Gallery__ThumbnailInput');
      const allImages = gallery.querySelectorAll('.Gallery__CurrentImage picture img');
  
      thumbnails.forEach(function(thumbnail) {
        thumbnail.addEventListener('change', function() {
          if (thumbnail.checked) {
            allImages.forEach(function(img) {
              const isSelectedImage = thumbnail.id === `${galleryId}-${img.getAttribute('id')}`;
              img.classList.toggle('selected-image', isSelectedImage); 
            });
          }
        });
      });
    });
  });


  // info dropdowns function

  function attachListeners() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest('[data-action="toggle-collapsible"]');
        if (target) {
            toggleCollapsible(event, target);
        }
    });
}

/**
 * Toggle a given collapsible
 */
function toggleCollapsible(event, target) {
    const parentCollapsible = target.closest('.Collapsible');

    // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
    if (parentCollapsible.classList.contains('Collapsible--autoExpand') && Responsive.matchesBreakpoint('tablet-and-up')) {
        return;
    }

    const isOpen = target.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
        closeCollapsible(parentCollapsible, target);
    } else {
        openCollapsible(parentCollapsible, target);
    }

    // Close any sibling collapsibles
    getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
        closeCollapsible(collapsibleToClose);
    });

    event.preventDefault();
}

/**
 * Open a given collapsible
 */
function openCollapsible(collapsible) {
    const toggleButton = collapsible.querySelector('.Collapsible__Button');
    const collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
        return; // It's already open
    }

    toggleButton.setAttribute('aria-expanded', 'true');
    collapsibleInner.style.height = collapsibleInner.scrollHeight + 'px';
    collapsibleInner.style.overflow = 'visible';

    collapsible.classList.add('is-open');
    collapsibleInner.addEventListener('transitionend', function onTransitionEnd() {
        collapsibleInner.style.height = 'auto'; // Reset height after animation
        collapsibleInner.removeEventListener('transitionend', onTransitionEnd);
    });
}

/**
 * Close a given collapsible
 */
function closeCollapsible(collapsible) {
    const toggleButton = collapsible.querySelector('.Collapsible__Button');
    const collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
        return; // It's already closed
    }

    toggleButton.setAttribute('aria-expanded', 'false');
    collapsibleInner.style.height = collapsibleInner.scrollHeight + 'px'; // Set to current height
    requestAnimationFrame(() => {
        collapsibleInner.style.height = '0'; // Collapse to 0 height
    });

    collapsible.classList.remove('is-open');
    collapsibleInner.style.overflow = 'hidden';
}

// Utility function to get siblings
function getSiblings(element) {
    return Array.from(element.parentNode.children).filter(function (child) {
        return child !== element;
    });
}

// Initialize listeners
attachListeners();


window.addEventListener("DOMContentLoaded", () => {
  const descriptionElement = document.querySelector('.CollectionDescription_Text');
  const toggleButton = document.getElementById('toggle-button-collection');

  if (descriptionElement && toggleButton) {
    const viewMore = toggleButton.getAttribute('data-view-more');
    const viewLess = toggleButton.getAttribute('data-view-less');
    const maxHeight = 100; // Adjust height limit

    function toggleDescription() {
      if (descriptionElement.classList.contains("collapsed")) {
        descriptionElement.style.maxHeight = "none";
        descriptionElement.classList.remove("collapsed");
        toggleButton.innerHTML = viewLess;
      } else {
        descriptionElement.style.maxHeight = maxHeight + "px";
        descriptionElement.classList.add("collapsed");
        toggleButton.innerHTML = viewMore;
      }
    }

    // Initialize
    descriptionElement.classList.remove('hide'); // Ensure it becomes visible
    toggleButton.style.display = "block"; // Always show the button
    toggleButton.addEventListener("click", toggleDescription);
  }
});

/* =============================================================
   OFF TV — WISHLIST CUSTOM (localStorage)
   ============================================================= */
(function () {
  const STORAGE_KEY    = 'offtv:wishlist';
  const KL_COMPANY_ID  = 'V6bebh';
  const KL_EMAIL_KEY   = 'offtv:kl_email';

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateCountBadges();
  }
  function isInList(productId) {
    return getList().some(p => String(p.id) === String(productId));
  }
  // forceModal: el botón «Guardar para el Black Friday» pide el email siempre que no lo tengamos
  function addToList(data, forceModal) {
    const list = getList();
    if (!list.some(p => String(p.id) === String(data.id))) {
      list.unshift(data);
      saveList(list);
    }
    const email = getKlEmail();
    if (email) {
      klConnectProduct(email, data);
      return;
    }
    klIsIdentified().then(function (identified) {
      if (identified) {
        klIdentifyAndTrack(null, data);
      } else if (forceModal || !sessionStorage.getItem('offtv:kl_shown')) {
        setTimeout(function () { showEmailModal(data, forceModal); }, forceModal ? 150 : 700);
      }
    });
  }
  function removeFromList(productId) {
    saveList(getList().filter(p => String(p.id) !== String(productId)));
    const email = getKlEmail();
    if (email) {
      klIdentify(email);
    } else {
      klIsIdentified().then(function (identified) { if (identified) klIdentify(null); });
    }
  }

  /* --- Klaviyo integration --- */
  // Packs: data-product-pack-key en el botón; si falta (listas antiguas), por handle
  const PACK_HANDLES = {
    'pack-cazador-2-bolsas-de-carne-correa-de-arrastre-colgador-de-corte-cartulina-de-despiece-afilador-work-sharp': 'cazador',
    'pack-perro-rehala': 'rehala',
    'pack-aguardo-ywh': 'aguardo'
  };
  function packKeyOf(item) {
    return item.packKey || PACK_HANDLES[item.handle] || '';
  }

  function getKlEmail() {
    return (window.offtvCustomer && window.offtvCustomer.email) ||
      localStorage.getItem(KL_EMAIL_KEY) || null;
  }
  function saveKlEmail(email) { localStorage.setItem(KL_EMAIL_KEY, email); }

  // Visitante ya identificado por Klaviyo (p. ej. llega desde un email) aunque no tengamos su email
  function klIsIdentified() {
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        return Promise.resolve(window.klaviyo.isIdentified()).then(Boolean).catch(function () { return false; });
      }
    } catch (e) {}
    return Promise.resolve(false);
  }

  function klIdentify(email) {
    const list = getList();
    const packs = [];
    list.forEach(function (item) {
      const k = packKeyOf(item);
      if (k && packs.indexOf(k) === -1) packs.push(k);
    });
    const props = {
      wishlist_handles: list.map(function (item) { return item.handle; }),
      wishlist_packs: packs
    };
    if (email) props['$email'] = email;
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', props]);
  }

  function klTrack(data) {
    const img = data.image || '';
    const packKey = packKeyOf(data);
    window._learnq = window._learnq || [];
    // $event_id propio: sin él Klaviyo deduplica por segundo y, al apuntarse con varios productos, solo guarda uno
    window._learnq.push(['track', 'Added to Wishlist', {
      $event_id: 'wl-' + data.id + '-' + Date.now(),
      ProductName: data.title,
      ProductID: String(data.id),
      ProductHandle: data.handle,
      URL: window.location.origin + data.url,
      ImageURL: img.startsWith('//') ? 'https:' + img : img,
      Price: (data.price / 100).toFixed(2),
      VariantID: data.variantId || '',
      IsPack: Boolean(packKey),
      PackKey: packKey
    }]);
  }

  function klIdentifyAndTrack(email, data) {
    klIdentify(email);
    klTrack(data);
  }

  function klBackInStock(email, variantId) {
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KL_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }})
    }).catch(function () {});
  }

  function klConnectProduct(email, data) {
    klIdentifyAndTrack(email, data);
    if (data.variantId) klBackInStock(email, data.variantId);
  }

  // Alta en la Lista VIP del Black Friday. En la API cliente el alta ya registra el consentimiento
  // de marketing (el perfil no admite «subscriptions»); el texto legal está en la hoja.
  function klSubscribeToList(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Wishlist BF26',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: 'Rg8dLa' } } }
      }})
    }).catch(function () {});
  }

  function showEmailModal(data, force) {
    if (document.getElementById('offtv-kl-modal')) return;
    if (!force && sessionStorage.getItem('offtv:kl_shown')) return;
    sessionStorage.setItem('offtv:kl_shown', '1');

    // Hueco inferior de 64px: la píldora «Preferencias de cookies» de Consentmo va en la capa superior
    // (popover) y queda por encima de cualquier z-index; sin hueco tapa «Ahora no».
    // z-index por encima del chat de Shopify Inbox (2147483000), que tapaba el texto legal.
    const modal = document.createElement('div');
    modal.id = 'offtv-kl-modal';
    modal.innerHTML = `
      <div id="offtv-kl-bd" style="position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:2147483001;"></div>
      <div id="offtv-kl-sheet" style="
        position:fixed;bottom:0;left:0;right:0;
        background:#111;border-top:1px solid #2a2a2a;border-radius:18px 18px 0 0;
        padding:28px 20px calc(64px + env(safe-area-inset-bottom));z-index:2147483002;
        transform:translateY(100%);transition:transform 0.35s cubic-bezier(0.32,0.72,0,1);
        max-width:480px;margin:0 auto;box-sizing:border-box;
      ">
        <div style="display:flex;align-items:flex-start;gap:12px;margin-bottom:18px;">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="#e62335" stroke="#e62335" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
          <div>
            <p style="margin:0;font-size:16px;font-weight:700;color:#f5f5f7;line-height:1.3;">Guarda tu lista para el Black Friday</p>
            <p style="margin:6px 0 0;font-size:14px;color:#a1a1a6;line-height:1.5;">Déjanos tu email y el viernes 20 te mandamos los precios VIP de lo que has guardado, 48 h antes que nadie.</p>
          </div>
        </div>
        <form id="offtv-kl-form" style="display:flex;gap:8px;margin-bottom:10px;">
          <input id="offtv-kl-email-inp" type="email" inputmode="email" autocomplete="email" placeholder="tu@email.com" required aria-label="Tu email"
            style="flex:1;min-width:0;background:#1a1a1a;border:1px solid #333;border-radius:8px;padding:12px 13px;color:#fff;font-size:16px;outline:none;"/>
          <button type="submit"
            style="background:#e62335;color:#fff;font-weight:700;font-size:14px;padding:12px 16px;border:none;border-radius:8px;cursor:pointer;white-space:nowrap;flex-shrink:0;">
            Apuntarme
          </button>
        </form>
        <p style="margin:0 0 10px;font-size:11.5px;color:#8e8e93;line-height:1.45;">
          Al apuntarte aceptas recibir emails de OFF TV. Puedes darte de baja cuando quieras.
          <a href="/policies/privacy-policy" style="color:#a1a1a6;text-decoration:underline;">Política de privacidad</a>
        </p>
        <button id="offtv-kl-skip" style="background:none;border:none;color:#8e8e93;font-size:12px;cursor:pointer;width:100%;text-align:center;padding:6px;">
          Ahora no
        </button>
      </div>
    `;
    document.body.appendChild(modal);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.getElementById('offtv-kl-sheet').style.transform = 'translateY(0)';
        setTimeout(function () {
          const inp = document.getElementById('offtv-kl-email-inp');
          if (inp) inp.focus();
        }, 360);
      });
    });

    function closeModal() {
      const sheet = document.getElementById('offtv-kl-sheet');
      if (sheet) sheet.style.transform = 'translateY(100%)';
      setTimeout(function () { modal.remove(); }, 360);
    }

    document.getElementById('offtv-kl-bd').addEventListener('click', closeModal);
    document.getElementById('offtv-kl-skip').addEventListener('click', closeModal);

    document.getElementById('offtv-kl-form').addEventListener('submit', function (e) {
      e.preventDefault();
      const emailVal = document.getElementById('offtv-kl-email-inp').value.trim();
      if (!emailVal) return;
      saveKlEmail(emailVal);
      klSubscribeToList(emailVal);
      // Klaviyo recibe toda la lista, no solo el último producto guardado
      klIdentify(emailVal);
      getList().forEach(function (item) {
        klTrack(item);
        if (item.variantId) klBackInStock(emailVal, item.variantId);
      });
      closeModal();
      showToast('Apuntado: te avisamos el viernes 20', false);
    });
  }

  function updateCountBadges() {
    const count = getList().length;
    document.querySelectorAll('[data-wl-count-badge]').forEach(el => {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    const headerCount = document.getElementById('header-wl-count');
    if (headerCount) {
      headerCount.textContent = count > 0 ? count : '';
      headerCount.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function syncButtons() {
    document.querySelectorAll('[data-wl-btn]').forEach(btn => {
      const id = btn.dataset.productId;
      btn.classList.toggle('is-active', isInList(id));
      btn.setAttribute('aria-label', isInList(id)
        ? 'Quitar de la lista de deseos'
        : `Guardar ${btn.dataset.productTitle || ''}`
      );
    });
  }

  function attachButton(btn) {
    if (btn._wlAttached) return;
    btn._wlAttached = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const id = btn.dataset.productId;
      if (isInList(id)) {
        removeFromList(id);
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', `Guardar ${btn.dataset.productTitle || ''}`);
        showToast('Eliminado de tu lista de deseos', false);
      } else {
        addToList({
          id: btn.dataset.productId,
          handle: btn.dataset.productHandle,
          title: btn.dataset.productTitle,
          price: Number(btn.dataset.productPrice),
          image: btn.dataset.productImage,
          url: btn.dataset.productUrl,
          variantId: btn.dataset.productVariantId || '',
          packKey: btn.dataset.productPackKey || ''
        }, btn.dataset.wlContext === 'bf');
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Quitar de la lista de deseos');
        showToast('Guardado en tu lista de deseos', true);
      }
    });
  }

  function showToast(message, isAdd) {
    let toast = document.getElementById('offtv-wl-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'offtv-wl-toast';
      toast.style.cssText = `
        position:fixed; bottom:24px; left:50%; transform:translateX(-50%) translateY(20px);
        background:#1a1a1a; border:1px solid #333; border-radius:50px;
        padding:10px 20px; font-size:13px; font-weight:600; color:#fff;
        display:flex; align-items:center; gap:8px; z-index:99999;
        opacity:0; transition:opacity 0.3s, transform 0.3s; pointer-events:auto;
        white-space:nowrap; cursor:default;
      `;
      document.body.appendChild(toast);
    }
    toast.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="${isAdd ? '#c62828' : 'none'}" stroke="#c62828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
      ${message}
      ${isAdd ? `<a href="/pages/wishlist" style="color:#c62828;text-decoration:none;font-weight:700">Ver lista</a>` : ''}
    `;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(10px)';
    }, 3000);
  }

  function init() {
    document.querySelectorAll('[data-wl-btn]').forEach(attachButton);
    syncButtons();
    updateCountBadges();
  }

  // MutationObserver for dynamically added buttons (quick buy, infinite scroll)
  const observer = new MutationObserver(() => {
    document.querySelectorAll('[data-wl-btn]:not([data-wl-attached])').forEach(btn => {
      attachButton(btn);
    });
    syncButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =============================================================
   OFF TV — INSTALLMENT BADGE: actualizar importes por variante
   ============================================================= */
(function () {
  function fmtInstallment(cents, divisor) {
    const ic = Math.round(cents / divisor);
    const e = Math.floor(ic / 100);
    const d = ic % 100;
    return e + ',' + (d < 10 ? '0' + d : d) + '€';
  }

  document.addEventListener('variant:change', function (e) {
    const variant = e.detail?.variant;
    if (!variant || !variant.price) return;
    const cents = variant.price;

    document.querySelectorAll('[data-installment-amount-3]').forEach(el => {
      el.textContent = fmtInstallment(cents, 3);
    });
    document.querySelectorAll('[data-installment-amount-4]').forEach(el => {
      el.textContent = fmtInstallment(cents, 4);
    });

    document.querySelectorAll('[data-installment-block]').forEach(block => {
      const min = parseInt(block.dataset.min || 3500, 10);
      block.style.display = cents >= min ? '' : 'none';
    });
  });
})();

/* =============================================================
   OFF TV — ADD TO CART (global) + VARIANT PICKER POPUP
   ============================================================= */

function offtvShowCartError(msg) {
  var t = document.getElementById('offtv-wl-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'offtv-wl-toast';
    t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);background:#1a1a1a;border:1px solid #333;border-radius:50px;padding:10px 20px;font-size:13px;font-weight:600;color:#fff;display:flex;align-items:center;gap:8px;z-index:99999;opacity:0;transition:opacity 0.3s,transform 0.3s;pointer-events:auto;white-space:nowrap;cursor:default;';
    document.body.appendChild(t);
  }
  t.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e62335" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' + msg;
  t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)';
  clearTimeout(t._timer);
  t._timer = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(10px)'; }, 3500);
}

function offtvDoAddToCart(variantId, button) {
  if (button) { button.style.opacity = '0.5'; button.style.pointerEvents = 'none'; }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
  })
  .then(function (r) {
    if (!r.ok) return r.json().then(function (err) { throw err; });
    return r.json();
  })
  .then(function () {
    if (button) { button.style.opacity = '1'; button.style.pointerEvents = 'auto'; }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') { drawer.show(); }
  })
  .catch(function (err) {
    if (button) { button.style.opacity = '1'; button.style.pointerEvents = 'auto'; }
    var msg = (err && err.description) ? err.description : 'Producto no disponible';
    offtvShowCartError(msg);
  });
}

function offtvShowVariantPicker(handle, button) {
  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      var existing = document.getElementById('offtv-variant-modal');
      if (existing) existing.remove();

      var modal = document.createElement('div');
      modal.id = 'offtv-variant-modal';
      modal.style.cssText = 'position:fixed;inset:0;z-index:100000;display:flex;align-items:flex-end;justify-content:center;';
      modal.innerHTML = '<div id="offtv-vm-overlay" style="position:absolute;inset:0;background:rgba(0,0,0,0.6);backdrop-filter:blur(2px);"></div>' +
        '<div id="offtv-vm-sheet" style="position:relative;background:#111;border-radius:20px 20px 0 0;width:100%;max-width:500px;padding:24px 20px 32px;z-index:1;transform:translateY(100%);transition:transform 0.3s cubic-bezier(0.25,0.46,0.45,0.94);">' +
        '<div style="width:40px;height:4px;background:#333;border-radius:2px;margin:0 auto 20px;"></div>' +
        '<div style="display:flex;align-items:center;gap:12px;margin-bottom:20px;">' +
        (product.featured_image ? '<img src="' + product.featured_image + '" style="width:56px;height:56px;object-fit:contain;border-radius:8px;background:#fff;padding:4px;" />' : '') +
        '<div><div style="font-size:13px;color:#888;margin-bottom:2px;">' + (product.vendor || '') + '</div>' +
        '<div style="font-size:15px;font-weight:600;color:#fff;line-height:1.3;">' + product.title + '</div></div></div>' +
        '<p style="font-size:12px;color:#888;margin:0 0 12px;text-transform:uppercase;letter-spacing:0.5px;">Elige una opción</p>' +
        '<div id="offtv-vm-options" style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:20px;"></div>' +
        '<button id="offtv-vm-add" disabled style="width:100%;height:44px;background:#e62335;color:#fff;border:none;border-radius:10px;font-size:15px;font-weight:700;cursor:pointer;opacity:0.4;transition:opacity 0.2s;">Añadir al carrito</button>' +
        '</div>';

      document.body.appendChild(modal);
      requestAnimationFrame(function () {
        document.getElementById('offtv-vm-sheet').style.transform = 'translateY(0)';
      });

      var selectedVariantId = null;
      var optionsContainer = document.getElementById('offtv-vm-options');
      var addBtn = document.getElementById('offtv-vm-add');

      product.variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.textContent = v.title === 'Default Title' ? v.option1 : v.title;
        btn.style.cssText = 'padding:8px 16px;border:1px solid #333;border-radius:8px;background:#1a1a1a;color:#ccc;font-size:14px;cursor:pointer;transition:all 0.15s;';
        if (!v.available) { btn.disabled = true; btn.style.opacity = '0.35'; btn.style.textDecoration = 'line-through'; }
        btn.addEventListener('click', function () {
          optionsContainer.querySelectorAll('button').forEach(function (b) {
            b.style.background = '#1a1a1a'; b.style.borderColor = '#333'; b.style.color = '#ccc';
          });
          btn.style.background = '#e62335'; btn.style.borderColor = '#e62335'; btn.style.color = '#fff';
          selectedVariantId = v.id;
          addBtn.disabled = false; addBtn.style.opacity = '1';
        });
        optionsContainer.appendChild(btn);
      });

      addBtn.addEventListener('click', function () {
        if (!selectedVariantId) return;
        modal.remove();
        offtvDoAddToCart(selectedVariantId, button);
      });

      document.getElementById('offtv-vm-overlay').addEventListener('click', function () {
        document.getElementById('offtv-vm-sheet').style.transform = 'translateY(100%)';
        setTimeout(function () { modal.remove(); }, 300);
      });
    });
}

window.addOffTvCardToCart = function (button) {
  if (button.dataset.hasVariants === 'true') {
    offtvShowVariantPicker(button.dataset.productHandle, button);
    return;
  }
  var variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;
  offtvDoAddToCart(variantId, button);
};

// ============================================================
// OFFTV SOCIAL PROOF & URGENCY
// ============================================================
(function () {
  var S = window.offtvSettings || {};

  // --- 1. Viewers Counter ---
  function offtvViewers() {
    if (S.viewersEnabled === false) return;
    var wrapper = document.getElementById('offtv-viewers');
    var countEl = document.getElementById('offtv-viewers-count');
    if (!wrapper || !countEl) return;

    var minV = S.viewersMin || 4;
    var maxV = S.viewersMax || 12;
    var current = Math.floor(Math.random() * (maxV - minV + 1)) + minV;
    countEl.textContent = current;
    wrapper.style.display = 'flex';

    function scheduleUpdate() {
      setTimeout(function () {
        var delta = Math.random() < 0.5 ? -1 : 1;
        current = Math.min(maxV, Math.max(minV, current + delta));
        countEl.textContent = current;
        scheduleUpdate();
      }, Math.floor(Math.random() * 20000) + 25000);
    }
    scheduleUpdate();
  }

  // --- 2. Dynamic Stock (visual only, never changes real inventory) ---
  function offtvDynamicStock() {
    if (S.dynamicStockEnabled === false) return;
    var span = document.querySelector('variant-inventory span:not([hidden])');
    if (!span) return;

    var realQty = parseInt(span.dataset.realQty, 10);
    var threshold = S.dynamicStockThreshold || 3;
    if (isNaN(realQty) || realQty <= threshold) return;

    var key = 'offtv_stk_' + window.location.pathname;
    var stored = sessionStorage.getItem(key);
    var shown;

    if (stored) {
      shown = parseInt(stored, 10);
    } else {
      var maxReduce = Math.min(5, realQty - threshold);
      shown = realQty - Math.floor(Math.random() * maxReduce) - 1;
      sessionStorage.setItem(key, shown);
    }

    if (/\d+/.test(span.textContent)) {
      span.textContent = span.textContent.replace(/\d+/, shown);
    }
  }

  // --- 3. Purchase Popup ---
  var NOMBRES = ['María','Carlos','Ana','Javier','Laura','Miguel','Paula','David','Sara','Alberto','Elena','Roberto','Marta','Francisco','Natalia','Sofía','Luis','Carmen','Alejandro','Lucía'];
  var CIUDADES = ['Madrid','Barcelona','Valencia','Sevilla','Zaragoza','Málaga','Bilbao','Murcia','Alicante','Córdoba','Valladolid','Vigo','Gijón','Vitoria','Granada','Pamplona','Santander','Burgos','Logroño','Toledo','Salamanca','Huelva','Almería','Cáceres','Badajoz'];
  var TIEMPOS = [2,3,4,5,7,8,10,12,15];
  var offtvProductTitles = [];
  var offtvLastProductIndex = -1;

  function offtvFetchProducts() {
    var page = Math.floor(Math.random() * 4) + 1;
    fetch('/collections/all/products.json?limit=12&page=' + page)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.products && data.products.length > 0) {
          offtvProductTitles = data.products.map(function (p) { return p.title; });
        }
      })
      .catch(function () {});
  }

  function offtvPickProduct() {
    if (!offtvProductTitles.length) return null;
    var idx;
    do { idx = Math.floor(Math.random() * offtvProductTitles.length); }
    while (offtvProductTitles.length > 1 && idx === offtvLastProductIndex);
    offtvLastProductIndex = idx;
    return offtvProductTitles[idx];
  }

  function offtvShowPopup() {
    var popup = document.getElementById('offtv-purchase-popup');
    if (!popup) return;

    var pos = S.popupPosition || 'right';
    popup.style.right = pos === 'right' ? '20px' : '';
    popup.style.left  = pos === 'left'  ? '20px' : '';

    var productName = offtvPickProduct() || 'un producto de la tienda';
    popup.querySelector('#offtv-popup-name').textContent = NOMBRES[Math.floor(Math.random() * NOMBRES.length)];
    popup.querySelector('#offtv-popup-city').textContent = CIUDADES[Math.floor(Math.random() * CIUDADES.length)];
    popup.querySelector('#offtv-popup-time').textContent = TIEMPOS[Math.floor(Math.random() * TIEMPOS.length)];
    popup.querySelector('#offtv-popup-product').textContent = productName;

    popup.style.display = 'block';
    popup.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.style.opacity = '1';
        popup.style.transform = 'translateY(0)';
      });
    });

    var duration = (S.popupDuration || 6) * 1000;
    setTimeout(function () {
      popup.style.opacity = '0';
      popup.style.transform = 'translateY(20px)';
      setTimeout(function () {
        popup.style.display = 'none';
        popup.setAttribute('aria-hidden', 'true');
      }, 360);
    }, duration);
  }

  function offtvPurchasePopup() {
    if (S.popupEnabled === false) return;
    if (!window.location.pathname.includes('/products/')) return;

    offtvFetchProducts();

    var firstDelay = (S.popupDelay || 20) * 1000;
    setTimeout(function () {
      offtvShowPopup();
      function scheduleNext() {
        setTimeout(function () {
          offtvShowPopup();
          scheduleNext();
        }, (S.popupInterval || 70) * 1000);
      }
      scheduleNext();
    }, firstDelay);
  }

  // --- Fix sticky product bar gap ---
  // overflow-x:hidden on <html> can break position:sticky on the nav header,
  // causing it to scroll off while --sticky-area-height still holds its height.
  // Result: ~65px gap of page content visible above the sticky bar.
  // Fix: track the header's actual viewport bottom on every scroll tick and
  // use inset-block-start (the logical property the theme uses) to reposition.
  function offtvFixStickyBarTop() {
    if (window.innerWidth < 700) return;
    var bar = document.querySelector('.product-sticky-bar');
    if (!bar) return;
    var headerSection = document.querySelector('.shopify-section--header');
    if (!headerSection) return;

    function adjust() {
      var rect = headerSection.getBoundingClientRect();
      // If header is sticky its bottom stays at ~headerHeight; if scrolled off ≤ 0
      var top = Math.max(0, Math.round(rect.bottom));
      bar.style.setProperty('inset-block-start', top + 'px');
    }

    var pending = false;
    window.addEventListener('scroll', function () {
      if (!pending) {
        pending = true;
        requestAnimationFrame(function () { adjust(); pending = false; });
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 700) adjust();
      else bar.style.removeProperty('inset-block-start');
    });

    adjust();
  }

  // --- Init ---
  document.addEventListener('DOMContentLoaded', function () {
    offtvViewers();
    offtvDynamicStock();
    offtvPurchasePopup();
    offtvFixStickyBarTop();
  });
})();

/* =============================================================
   OFF TV — SEARCH MODAL FIX
   Problema: el input del buscador no recibe foco al abrirse,
   haciendo que las primeras teclas no se registren.
   Fix: forzar foco tras el evento dialog:after-show + asegurar
   que el contenido no quede tapado por el overlay del Shadow DOM.
   ============================================================= */
(function () {
  // Asegurar que el contenido del buscador esté por encima del overlay
  // (el overlay shadow DOM es position:fixed y se apila sobre elementos estáticos)
  var searchStyle = document.createElement('style');
  searchStyle.textContent = [
    '.header-search::part(content){position:relative;z-index:1;}',
    '.offtv-size-pills{display:flex;flex-wrap:wrap;gap:4px;justify-content:center;margin-top:5px;}',
    '.offtv-size-pill{font-size:10px;line-height:1;padding:3px 7px;border:1px solid currentColor;border-radius:50px;opacity:.85;white-space:nowrap;min-width:20px;text-align:center;}',
    '.offtv-size-pill--out{opacity:.25;text-decoration:line-through;}'
    // '.offtv-pro-card--sold-out{order:1;}' se ha movido al <style> de
    // sections/main-collection.liquid. Inyectada desde aquí llegaba después del
    // primer pintado y reordenaba la rejilla entera: 0,377 de CLS. No devolverla.
  ].join('');
  document.head.appendChild(searchStyle);

  function initSearchFix() {
    var headerSearch = document.querySelector('header-search');
    if (!headerSearch) return;

    headerSearch.addEventListener('dialog:after-show', function () {
      var input = headerSearch.querySelector('.header-search__input');
      if (!input) return;
      // Doble rAF: garantiza que el navegador ha pintado y el foco no
      // se pierde por la animación de entrada o el focus-trap del tema.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          input.focus({ preventScroll: true });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchFix);
  } else {
    initSearchFix();
  }
})();
